import {Injectable} from '@angular/core';
import {User} from "../../models/user";
import {firstValueFrom} from "rxjs";
import {ApiService} from "../sp-api/api.service";
import { CookieService } from 'ngx-cookie-service';
import { OAuthService } from './oauth.service';
import { SessionProviderService } from './session-provider.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  public static readonly authImpersonationCookie: string = 'sp-creds-impersonation';

  constructor(private api: ApiService, private cookieService: CookieService, private oauth: OAuthService, private sessionProvider: SessionProviderService) {}

  async loginImpersonate(user: User|{id: number}): Promise<void> {
    const response = await firstValueFrom(this.api.post<any>("auth/impersonate/" + user.id));
    this.cookieService.set(AuthService.authImpersonationCookie, response.token, undefined, '/');
    this.sessionProvider.initializeSession();
  }

  async redirectToLogin() {
    await this.oauth.login();
  }
}
